import { Box, Switch, Typography } from '@material-ui/core';
import React from 'react';
import { useCampfireLazyQuery } from '../../../../../global/network/useCampfireLazyQuery';
import { useSnackbar } from '../../../../../global/config/useSnackbar';
import { useCampfireFetch } from '../../../../../global/network/useCampfireFetch';
import { useApiUrl } from '../../../../../global/config/useApiUrl';
import { GET_CONFIG_ITEM } from './config-item.gql';
import { GetConfigItem } from './__generated__/GetConfigItem';

export function AllowVolunteerActivityCancellation() {
  const [queryConfigItem] = useCampfireLazyQuery<GetConfigItem, { key: string }>(GET_CONFIG_ITEM);
  const [enabled, setEnabled] = React.useState<boolean | undefined>();
  const { setSnackbar } = useSnackbar();

  React.useEffect(() => {
    queryConfigItem({ variables: { key: 'allow-volunteer-activity-cancellation' } }).then((response) =>
      setEnabled(response.data?.vm.configItem?.configItemValue?.flagValue ?? response.data?.vm.configItem?.defaultValue)
    );
  }, []);

  const saveConfigItem = useCampfireFetch({ defer: true });

  const apiUrl = useApiUrl();
  const onSave = () => {
    saveConfigItem
      .run({
        url: `${apiUrl}/vm/admin-console/operations/config-item`,
        method: 'post',
        data: {
          key: 'allow-volunteer-activity-cancellation',
          value: !enabled,
        },
      })
      .then(() => {
        setSnackbar({
          open: true,
          message: 'Successfully updated',
          variant: 'success',
        });
      });
    setEnabled(!enabled);
  };

  return (
    <Box mt={2}>
      <Box display='flex' alignItems={'center'}>
        <Switch
          checked={Boolean(enabled)}
          onChange={onSave}
          color='primary'
          inputProps={{ 'aria-label': 'allow volunteer roster cancellation' }}
        />
        <Box ml={1}>
          <Typography
            style={{
              fontWeight: 500,
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            Allow Volunteer Roster Cancellation
          </Typography>
          <Typography variant={'body2'} style={{ fontSize: '13px', color: '#808080' }}>
            {
              'Allow rostered volunteers to cancel a roster occurrence from the activity report screen. Activity Leaders, Program Managers, and Admins can always cancel rosters.'
            }
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
